import API from "./restAPI";
import axios, { AxiosResponse, CancelToken, CancelTokenSource } from "axios";

let config = require("../configuration.json");

// axios 0.21 nepodporuje AbortSignal, zruseni se dela pres CancelToken
export function createCancelSource(): CancelTokenSource {
    return axios.CancelToken.source();
}

export function isCancel(error: any): boolean {
    return axios.isCancel(error);
}

export function apiExportReceiptsCsv(productIdsAsString:string, sampleCardId: number, allSampleCards:boolean, pigmentsUnit: any, baseUnit: any, cancelToken?: CancelToken):
    Promise<AxiosResponse> {
    return API.get(`${config.serverUrl}/api/exportreceiptscsv/${productIdsAsString}/${sampleCardId}/${allSampleCards}/${pigmentsUnit}/${baseUnit}`,
        { responseType: 'blob', cancelToken });
}

export function apiExportSpecialReceiptsCsv(pigmentsUnit: any, baseUnit: any):
    Promise<AxiosResponse> {
    return API.get(`${config.serverUrl}/api/exportspecialreceiptscsv/${pigmentsUnit}/${baseUnit}`,
        { responseType: 'blob' });
}
